import React from 'react'

const withContainer = Component => props => {
  const { DRIVER_CAN_CALL_CLIENT, CLIENT_CAN_CALL_DRIVER } = props || {}

  const mergedProps = {
    DRIVER_CAN_CALL_CLIENT,
    CLIENT_CAN_CALL_DRIVER,
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
